declare const brand: unique symbol;

export type Branded<T extends string> = string & { readonly [brand]: T };

// lib is ES2023 (no DOM) and @types/node declares no `crypto` global; both runtimes have it.
declare const crypto: {
  getRandomValues<T extends ArrayBufferView>(array: T): T;
};

export function uuidv7(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // DataView because noUncheckedIndexedAccess makes an indexed read undefined and `!` is banned.
  const view = new DataView(bytes.buffer);
  const timestamp = Date.now();

  // 48-bit timestamp, split because setUint32 caps at 32.
  view.setUint16(0, Math.floor(timestamp / 2 ** 32));
  view.setUint32(2, timestamp % 2 ** 32);

  view.setUint8(6, (view.getUint8(6) & 0x0f) | 0x70);
  view.setUint8(8, (view.getUint8(8) & 0x3f) | 0x80);

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

// Brand as a value: a single-use type parameter would be an unchecked assertion.
export function brandId<T extends string>(brand: T, value: string): Branded<T> {
  return value as Branded<T>;
}

export function newId<T extends string>(brand: T): Branded<T> {
  return brandId(brand, uuidv7());
}
